<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">{{ modalTitle }} </h5>
</div>
<div class="modal-body">
    <form [formGroup]="documentsForm">

        <div class="row">
            <div class="col">
                <mdb-form-control>
                    <input mdbInput mdbValidate required type="text" id="documentName-input" class="form-control"
                        formControlName="documentName"/>
                    <label mdbLabel class="form-label" for="documentName-input">Nombre del Documento (mínimo 5
                        caracteres) </label>

                    <mdb-error *ngIf="
          
          documentsForm.get('documentName')?.invalid && (documentsForm.get('documentName')?.dirty || documentsForm.get('documentName')?.touched)
              "><i class="fa fa-close" style="color:red"></i></mdb-error>
                    <mdb-success *ngIf="
              documentsForm.get('documentName')?.valid && (documentsForm.get('documentName')?.dirty || documentsForm.get('documentName')?.touched)
              "><i class="fa fa-check" style="color:green"></i></mdb-success>
                </mdb-form-control>
                <div *ngIf="documentsForm?.get('documentName')?.errors?.['minlength']"></div>
            </div>
            <div class="col" *ngIf="insertType==3">
                <mdb-form-control>
                    <input mdbInput mdbValidate type="text" id="documentCode" class="form-control" formControlName="documentCode"/>
                    <label mdbLabel class="form-label" for="documentCode">Codigo Documento</label>
                </mdb-form-control>
            </div>
            <div class="col" *ngIf="insertType==3">
                <mdb-form-control>
                    <mdb-select mdbValidate [filter]="true" placeholder="Seleccione Gerencia" formControlName="documentGerencia"
                        (valueChange)="onChangeGerencia($event)">
                        <mdb-option *ngFor="let option of gerenciasSinRepetir" [value]="option.value">{{
                            option.label}}</mdb-option>
                    </mdb-select>
                    <label mdbLabel class="form-label">Gerencia</label>
                </mdb-form-control>
            </div>
        </div>
        <hr class="hr hr-blurry" />
        <div class="row" *ngIf="insertType==3">
            <div class="col">
                <mdb-form-control>
                    <mdb-select mdbValidate [filter]="true" placeholder="Seleccione Area" formControlName="documentArea">
                        <mdb-option *ngFor="let option of areasSeleccionadas" [value]="option.value">{{
                            option.label}}</mdb-option>
                    </mdb-select>
                    <label mdbLabel class="form-label">Area</label>
                </mdb-form-control>
            </div>
            <div class="col" *ngIf="insertType==3">
                <mdb-form-control>
                    <mdb-select mdbValidate [filter]="true" placeholder="Seleccione Usuario Creador"
                        formControlName="usuarioCreador">
                        <mdb-option *ngFor="let option of InfoUsers" [value]="option.value">{{
                            option.label}}</mdb-option>
                    </mdb-select>
                    <label mdbLabel class="form-label">Usuario Creador</label>
                </mdb-form-control>
            </div>
            <div class="col" *ngIf="insertType==3">
                <mdb-form-control>
                    <input mdbValidate mdbInput [mdbDatepicker]="datepicker" type="text" class="form-control"
                        (click)="datepicker.open()" formControlName="fechaCreacion" />
                    <label mdbLabel class="form-label">Fecha de creación</label>
                    <mdb-datepicker-toggle [icon]="'fas fa-calendar'"
                        [mdbDatepicker]="datepicker"></mdb-datepicker-toggle>
                    <mdb-datepicker [inline]="true" #datepicker></mdb-datepicker>
                </mdb-form-control>
            </div>
        </div>
        <hr class="hr hr-blurry" />

        <div class="row" *ngIf="insertType==3">
            <div class="col">
                <mdb-form-control>
                    <mdb-select mdbValidate [filter]="true" placeholder="Seleccione Usuario Revisión"
                        formControlName="usuarioRevision">
                        <mdb-option *ngFor="let option of InfoUsers" [value]="option.value">{{
                            option.label}}</mdb-option>
                    </mdb-select>
                    <label mdbLabel class="form-label">Usuario Revisión</label>
                </mdb-form-control>
            </div>
            <div class="col" *ngIf="insertType==3">
                <mdb-form-control>
                    <input mdbValidate mdbInput [mdbDatepicker]="datepicker" type="text" class="form-control"
                        formControlName="fechaRevision" (click)="datepicker.open()" />
                    <label mdbLabel for="exampleDatepicker" class="form-label">Fecha de Revisión</label>
                    <mdb-datepicker-toggle [icon]="'fas fa-calendar'"
                        [mdbDatepicker]="datepicker"></mdb-datepicker-toggle>
                    <mdb-datepicker [inline]="true" #datepicker></mdb-datepicker>
                </mdb-form-control>
            </div>
            <div class="col" *ngIf="insertType==3">
                <mdb-form-control>
                    <mdb-select mdbValidate [filter]="true" placeholder="Seleccione Usuario Aprobador"
                        formControlName="usuarioAprobador">
                        <mdb-option *ngFor="let option of InfoUsers" [value]="option.value">{{
                            option.label}}</mdb-option>
                    </mdb-select>
                    <label mdbLabel class="form-label">Usuario Aprobador</label>
                </mdb-form-control>
            </div>
        </div>
        <hr class="hr hr-blurry" />

        <div class="row" *ngIf="insertType==3">
            <div class="col">
                <mdb-form-control>
                    <input mdbValidate mdbInput [mdbDatepicker]="datepicker" type="text" class="form-control"
                        formControlName="fechaAprobacion" (click)="datepicker.open()" />
                    <label mdbLabel for="exampleDatepicker" class="form-label">Seleccione fecha de Aprobación</label>
                    <mdb-datepicker-toggle [icon]="'fas fa-calendar'"
                        [mdbDatepicker]="datepicker"></mdb-datepicker-toggle>
                    <mdb-datepicker [inline]="true" #datepicker></mdb-datepicker>
                </mdb-form-control>
            </div>
            <div class="col" *ngIf="insertType==3">
                <mdb-form-control>
                    <mdb-select mdbValidate [filter]="true" placeholder="Seleccione Usuario Publicador"
                        formControlName="usuarioPublicador">
                        <mdb-option *ngFor="let option of InfoUsers" [value]="option.value">{{
                            option.label}}</mdb-option>
                    </mdb-select>
                    <label mdbLabel class="form-label">Usuario Publicador</label>
                </mdb-form-control>
            </div>
            <div class="col" *ngIf="insertType==3">
                <mdb-form-control>
                    <input mdbValidate mdbInput [mdbDatepicker]="datepicker" type="text" class="form-control"
                        formControlName="fechaPublicacion" (click)="datepicker.open()" />
                    <label mdbLabel for="exampleDatepicker" class="form-label">Seleccione fecha de publicación</label>
                    <mdb-datepicker-toggle [icon]="'fas fa-calendar'"
                        [mdbDatepicker]="datepicker"></mdb-datepicker-toggle>
                    <mdb-datepicker [inline]="true" #datepicker></mdb-datepicker>
                </mdb-form-control>
            </div>
        </div>
        <hr class="hr hr-blurry" />

        <div class="col" *ngIf="insertType==3">
            <mdb-chips>
                <mdb-form-control class="chips-input-wrapper chips-transition w-100"
                    [class.chips-padding]="tags.length > 0">
                    <!--label mdbLabel class="form-label">Ingrese: Código de Documento, Palabras Claves, Nombre de Documento</label-->
                    <mdb-chip *ngFor="let tag of tags" (deleted)="delete(tag)">
                        <span class="text-chip">{{ tag.name }}</span>
                        <i class="close fas fa-times" mdbChipDelete></i>
                    </mdb-chip>
                    <input mdbValidate (keydown.enter)="onEnterPress()" mdbChipsInput class="form-control chips-input"
                        (chipAdd)="add($event)" placeholder="Palabras Claves" />
                </mdb-form-control>
            </mdb-chips>
        </div>
        <!--  END FORM DOCUMENTO ALL FIELDS (insertType==3) -->
        <div *ngIf="insertType==2 || insertType==3" class="my-4 table-editor_input-wrapper">
            <mdb-form-control>
                <mdb-select mdbValidate placeholder="Seleccione Tipo de Documento" formControlName="TipoDocumento"
                    (valueChange)="onTipoDocumentoSelected($event)">
                    <mdb-option *ngFor="let option of TipoDocumento" [value]="option.value">{{ option.label
                        }}</mdb-option>
                </mdb-select>
            </mdb-form-control>
        </div>
        <div *ngIf="insertType==3" class="my-4 table-editor_input-wrapper">
            <mdb-form-control>
                <!--label mdbLabel class="form-label">Seleccione Detalle de Documento</label-->
                <mdb-select mdbValidate placeholder="Seleccione Detalle de Documento" formControlName="DetalleTipoDocumento"
                    (valueChange)="onChangeDetalleTipoDocumentoSelected($event)">
                    <mdb-option *ngFor="let option of DetalleTipoDocumento" [value]="option.value">{{ option.label
                        }}</mdb-option>
                </mdb-select>
            </mdb-form-control>
        </div>

        <div *ngIf="insertType==3" class="my-4 table-editor_input-wrapper">
            <div class="col-md-12">
                <mdb-file-upload #fileUpload [defaultPreview]="'https://i.imgur.com/lZHadNk.png'" [removeBtn]="'Eliminar'"
                    [defaultMsg]="'Seleccione Documento PDF'"
                    [previewMsg]="'Arrastre o haga click para seleccionar otro archivo'" [removeBtnDisabled]="true"
                    (fileAdded)="onFileAdded($event)">
                </mdb-file-upload>
            </div>
        </div>


    </form>
</div>
<div class="modal-footer">
    <button type="button" class="shadow-0 btn btn-md btn-outline-primary" (click)="modalRefDocuments.close()">
        Cancelar
    </button>
    <button type="button" class="shadow-0 btn btn-md btn-primary" (click)="InsertOrUpdate()"
        [textContent]="edit === 0 ? 'Guardar' : 'Editar'"
        [disabled]="documentsForm.invalid || (archivo == null && insertType==3 && edit == 0)">
    </button>
</div>

<mdb-loading [show]="loadingFull" [fullscreen]="true">
    <div class="loading-spinner">
        <div class="spinner-border loading-icon" role="status"></div>
        <span class="loading-text">Cargando datos...</span>
    </div>
</mdb-loading>